import { Routes } from '@angular/router';
import { hisRoutes } from 'hisng';

import { HISINONERES, HISINONEKDSF, HISINONEDOC, HISINONEBIA } from 'app/fs/res/common/model/constants';

export const ROUTES: Routes = hisRoutes([
    {
        path: 'employment',
        loadChildren: () => import( './fs/res/employment/employment.routes' ).then( m => m.ROUTES),
        data: {
            modules: [ HISINONERES, HISINONEKDSF ]
        }
    },
    {
        path: 'doctoral',
        loadChildren: () => import( './fs/res/doctoral/doctoral.routes' ).then( m => m.ROUTES),
        data: {
            modules: [ HISINONEDOC, HISINONERES, HISINONEKDSF ]
        }
    },
    {
        path: 'finance',
        loadChildren: () => import( './fs/res/finance/finance.routes' ).then( m => m.ROUTES),
        data: {
            anonmodules: [ HISINONERES, HISINONEKDSF ],
            modules: [ HISINONEBIA, HISINONERES, HISINONEKDSF ]
        },
    },
    {
        path: 'researchRelationship',
        loadChildren: () => import( './fs/res/research-relationship/research-relationship.routes' ).then(
            m => m.ROUTES),
        data: {
            modules: [ HISINONERES, HISINONEKDSF ]
        }
    },
    {
        path: 'pub',
        loadChildren: () => import( './fs/res/publication/publication.routes' ).then( m => m.ROUTES),
        data: {
            modules: [ HISINONERES, HISINONEKDSF ]
        }
    },
    {
        path: 'patent',
        loadChildren: () => import( './fs/res/patent/patent.routes' ).then( m => m.ROUTES),
        data: {
            modules: [ HISINONERES, HISINONEKDSF ]
        }
    },
    {
        path: 'researchActivity',
        loadChildren: () => import( './fs/res/research-activity/research-activity.routes' ).then(
            m => m.ROUTES
        ),
        data: {
            modules: [ HISINONERES ]
        }
    },
    {
        path: 'researchInfrastructure',
        loadChildren: () => import( './fs/res/research-infrastructure/research-infrastructure.routes' ).then(
            m => m.ROUTES
        ),
        data: {
            modules: [ HISINONERES, HISINONEKDSF ]
        }
    },
    {
        path: 'prizeNomination',
        loadChildren: () => import( './fs/res/prize-nomination/prize-nomination.routes' ).then(
            m => m.ROUTES
        ),
        data: {
            modules: [ HISINONERES ]
        }
    }
]);
